import React, {
  useState,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Moment from 'react-moment';
import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => createStyles({
  root: {
    color: '#212121',
    backgroundColor: '#fafafa',
    borderTop: '1px solid #bdbdbd',
  },
  description: {
    color: '#212121',
    padding: 20,
  },
}));

export default function ReportCardsDetailsSummaryComment({
  id,
  selectedDate,
}) {
  const classes = useStyles();
  const { t } = useTranslation(undefined, { useSuspense: false });
  const selectedPupil = useSelector(state => state.selectedPupil);
  const [isLoading, setLoading] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  let axiosCancel = null;

  useEffect(() => {
    load();

    return () => {
      if (axiosCancel) {
        axiosCancel();
      }
    };
  }, [selectedDate, id]);

  const load = () => {
    if (axiosCancel) {
      axiosCancel();
    }

    setLoading(true);

    axios
      .get(
        `${window.apiUrl}/getpupilreportcardsummarycomment/${id}?date=${selectedDate}&pupil_id=${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        } else {
          setError(response.data.error);
        }

        setLoading(false);
        setLoaded(true);
      })
      .catch((thrown) => {});
  };

  return (
    <div className={`report-cards-details-summary-comment ${classes.root}`}>
      {isLoading && (
        <CircularProgress />
      )}
      {!isLoading && isLoaded && error && (
        <>{error}</>
      )}
      {!isLoading && isLoaded && !error && (
        <div className={classes.description}>
          {!data.id && t('No summary left for this date')}
          {!!data.id && (
            <>
              <p>{data.text}</p>
              <p><small><Moment date={data.date} format={dateFormat + ' HH:mm'} /> {t('by')} {data.teacher_name}</small></p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
